import {
  IAdminOwnershipDetailsData,
  convertToDecimals,
} from '@pharmaplan/common';

import { currencyFormatter } from '../../../../helpers/Functions';
import { DynamicTableCell } from '../../../../helpers/Constants';
import { getDayMonthDateYear } from '../../../Reports/helpers';
import strings from '../../../../localization';

import { IAllowancesBreakdown } from './AllowancesBreakdown';

const { text, customLink } = DynamicTableCell;

interface IOwnershipBookingsRow {
  bookings: Array<IAdminOwnershipDetailsData>;
  showAllowances: (allowances: IAllowancesBreakdown) => () => void;
}

export const ownershipBookingsHeader = () =>
  [
    {
      key: '0',
      label: strings.workshiftDateText,
      sortingKey: 'selectedDate',
    },
    {
      key: '1',
      label: strings.hours,
      isCenterAligned: true,
      sortingKey: 'totalHours',
    },
    {
      key: '2',
      label: strings.pharmacistHourlyRate,
      isCenterAligned: true,
      sortingKey: 'professionalHourlyRate',
    },
    {
      key: '3',
      label: strings.pharmacyHourlyRate,
      isCenterAligned: true,
      sortingKey: 'pharmacyHourlyRate',
    },
    {
      key: '4',
      label: strings.totalAllowance,
      isCenterAligned: true,
      sortingKey: 'totalAllowance',
    },
    {
      key: '5',
      label: strings.totalPaid,
      isCenterAligned: true,
      sortingKey: 'totalPaid',
    },
    {
      key: '6',
      label: strings.totalCharged,
      isCenterAligned: true,
      sortingKey: 'totalCharged',
    },
  ];

export const ownershipBookingsRow = ({
  bookings,
  showAllowances,
}: IOwnershipBookingsRow) =>
  bookings.map((item) => {
    const {
      selectedDate,
      totalHours = 0,
      professionalHourlyRate = 0,
      pharmacyHourlyRate = 0,
      totalAllowance = 0,
      accommodationAllowance = 0,
      travelAllowance = 0,
      mealAllowance = 0,
      emergencyFees = 0,
      otherAllowance = 0,
      totalPaid = 0,
      totalCharged = 0,
    } = item ?? {};

    return {
      key: selectedDate,
      data: [
        {
          key: `0-${selectedDate}`,
          value: getDayMonthDateYear(selectedDate),
          type: text,
        },
        {
          key: `1-${selectedDate}`,
          value: convertToDecimals(totalHours),
          type: text,
          isCenterAligned: true,
        },
        {
          key: `2-${selectedDate}`,
          value: currencyFormatter(professionalHourlyRate),
          type: text,
          isCenterAligned: true,
        },
        {
          key: `3-${selectedDate}`,
          value: currencyFormatter(pharmacyHourlyRate),
          type: text,
          isCenterAligned: true,
        },
        {
          key: `4-${selectedDate}`,
          value: totalAllowance ? {
            label: currencyFormatter(totalAllowance),
            handlePress: showAllowances({
              accommodationAllowance,
              travelAllowance,
              mealAllowance,
              emergencyFees,
              otherAllowance,
              totalAllowance,
            }),
          } : totalAllowance,
          type: totalAllowance ? customLink : text,
          isCenterAligned: true,
        },
        {
          key: `5-${selectedDate}`,
          value: currencyFormatter(totalPaid),
          type: text,
          isCenterAligned: true,
        },
        {
          key: `6-${selectedDate}`,
          value: currencyFormatter(totalCharged),
          type: text,
          isCenterAligned: true,
        },
      ],
    };
  });
